import { InteractionManager } from "../../lib/interaction";
import { AreaInteraction } from "../interactions/AreaInteraction";
import { BldMoveInteraction } from "../interactions/BldMoveInteraction";
import { GroupInteraction } from "../interactions/GroupInteraction";
import { LengthInteraction } from "../interactions/LengthInteraction";
import { ZoomInteraction } from "../interactions/ZoomInteraction";
import { GroupLayer, MeasureLayer, ZoomboxLayer } from "../layers/client/ClientLayers";
export class GSAInteractionManager extends InteractionManager {
    constructor(map, p_layer, s_layer) {
        super(map);
        this.add_interactions(new AreaInteraction(map, MeasureLayer), new BldMoveInteraction(map, s_layer), new GroupInteraction(GroupLayer, p_layer, 'group'), new GroupInteraction(GroupLayer, p_layer, 'nh'), new GroupInteraction(GroupLayer, p_layer, 'sale'), new GroupInteraction(GroupLayer, p_layer, 'land'), new LengthInteraction(map, MeasureLayer), new ZoomInteraction(map, ZoomboxLayer));
    }
}
